export default "__VITE_ASSET__c837d182__"